import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useSubmittalTrackerContext } from '../../../SubmittalTrackerContext'
import { Submittal } from '../../../SubmittalTrackerContext/types'

export function usePayItemsOptions(): PayItemsOptions<Submittal> {
  const { payItemGlobalId } = useSubmittalTrackerContext()
  return {
    hidden: !!payItemGlobalId,
    globalId: payItemGlobalId,
    onFilter: (value, { casToPayItemNoGeometries }) =>
      casToPayItemNoGeometries.some(
        ({ payItem: { globalId } }) => value === globalId
      ),
  }
}
